import React, { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';
import './NetworkStatus.css';

/**
 * Soft offline banner. Uses online/offline events (not a hard request gate).
 * Starts optimistic (online) to avoid false offline flashes on load.
 */
function NetworkStatus() {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    // Soft hint only — event-driven after mount
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      setIsOffline(true);
    }

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="network-status-banner" role="status" aria-live="polite">
      <WifiOff size={16} strokeWidth={2} aria-hidden="true" />
      <span>No internet connection. Please check your network.</span>
    </div>
  );
}

export default NetworkStatus;
